var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHarbour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1789 70.9994C33.1789 70.9994 26.5629 65.2609 31.5533 60.5938C36.9188 55.5644 43.0232 62.7828 43.0232 62.7828",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3491 61.2757C42.3491 61.2757 43.8837 59.5916 45.8617 60.2506C46.4137 60.4103 46.9191 60.7043 47.3344 61.1072C47.7496 61.5101 48.0622 62.0097 48.2451 62.563C48.2451 62.563 49.8479 60.5975 52.5193 61.8847C55.1907 63.1719 52.7618 65.8388 52.7618 65.8388",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9841 64.4637C60.9841 64.4637 56.9486 64.6603 54.1636 63.4463",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 63.3888C21.1143 63.3888 21.4553 52.8636 21.6447 50.9443C21.8342 49.0251 21.569 48.4046 22.9293 48.5626C24.2896 48.7206 34.9637 49.0482 38.7719 48.8979",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4297 47.4987C23.4297 47.4987 24.718 34.8308 24.9984 32.3835C25.2712 30.1598 25.2068 28.6221 28.0866 29.3004C31.5878 30.1174 43.5086 30.1868 43.3419 30.021",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1989 47.179L45.3043 30.1214C45.3043 30.1214 45.4028 25.3309 45.6567 21.5695C45.9106 17.808 48.078 18.9565 39.935 18.0123C31.7921 17.0681 31.739 15.8541 31.4548 17.5267C31.1593 19.3072 27.749 28.7648 27.749 28.7648",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1209 40.0645C19.1209 40.0645 18.5032 38.7465 20.0492 37.8023C21.7278 36.781 23.433 37.3436 24.4144 37.8447",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0977 43.0055C16.7642 42.6394 15.457 40.6932 17.0977 39.6102C17.3985 39.3678 17.7815 39.2564 18.1628 39.3005C18.5442 39.3445 18.8928 39.5404 19.1325 39.8453",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9079 41.417C15.9079 41.417 9.66334 41.9912 8.29166 47.3559C7.09806 52.0077 9.77323 54.6283 12.5924 55.8809C15.5101 57.1835 20.9286 55.3991 20.9286 55.3991",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9431 66.1906C27.5218 66.3794 12.9979 67.4508 15.313 66.1906C17.8366 64.807 24.3199 63.1074 24.3199 63.1074",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7697 49.6182C54.7697 49.6182 57.8011 51.1174 55.5275 53.4413C53.5647 55.4338 50.0484 54.5088 49.4648 54.135",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6682 52.4282C56.6682 52.4282 62.4239 53.7462 63.8449 50.5474C65.0612 47.8188 58.7219 46.7551 58.7219 46.7551C58.7219 46.7551 59.385 44.4004 56.4711 43.5024C55.7112 43.2638 54.9016 43.2407 54.1297 43.4356C53.3578 43.6305 52.6528 44.0361 52.0908 44.6085",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0742 41.6675C48.3512 40.9236 49.7532 40.1259 51.4507 40.8003C53.5803 41.6636 53.3453 43.6214 53.3453 43.6214",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1807 17.5265L38.6995 10.5547",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3608 16.6324C33.3608 16.6324 34.581 10.9517 35.2175 9.69531",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9062 17.8546C44.3039 15.5422 44.0577 10.4512 44.0577 10.4512",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2433 8.91669L39.6095 9.98424L47.5668 10.493C47.6358 10.4959 47.7039 10.4767 47.7616 10.4381C47.8192 10.3995 47.8636 10.3435 47.8882 10.2779C47.9129 10.2123 47.9168 10.1405 47.8992 10.0726C47.8817 10.0047 47.8436 9.94416 47.7904 9.89945L41.4776 4.80838C41.4776 4.80838 41.3904 1.05848 40.7728 1.00067C40.1552 0.942865 39.2116 4.61954 39.2116 4.61954L32.1448 8.34631C32.089 8.37646 32.044 8.42381 32.0162 8.48158C31.9885 8.53935 31.9794 8.60457 31.9904 8.6679C32.0013 8.73123 32.0317 8.7894 32.0771 8.8341C32.1226 8.87879 32.1807 8.9077 32.2433 8.91669V8.91669Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarbour);
export default __webpack_public_path__ + "static/media/harbour.47b755f564d00bd60470e61c7267153c.svg";
export { ForwardRef as ReactComponent };